import { variantType } from "@/types";
import { GENERATED_ASSETS_CONSTANT } from "../asset-generation/components/ReviewAssets/constants";
import { PROJECT_OPTIONS_CONSTANT } from "../asset-generation/components/ExploreOptions/constant";

export const BACKGROUND_GENERATION_STEPS_CONSTANTS = {
  STEP_NAMES: {
    1: "Explore options",
    2: "Add inputs",
    3: "Review assets",
  },
};

export const BACKGROUND_EXPLORE_OPTIONS_CONSTANTS = {
  TITLE: PROJECT_OPTIONS_CONSTANT.TITLE,
  HEADING_ID: "selectProjectOptionsHeadingID",
  DESCRIPTION:
    "Tell us what type of asset you'd like to create and your intended channels. Generate background images and messaging for digital content and marketing concepts.",
};

export const BACKGROUND_INPUTS_CONSTANTS = {
  TITLE: "Generate Assets",
  HEADING_ID: "selecInputHeadingID",
  DESCRIPTION:
    "Providing a detailed description helps generate the highest-quality outputs. Keep in mind that narrow, contextually specific inputs tend to outperform broad descriptions. Review our brief guidelines below for more help. ",
};

export const BACKGROUND_INPUTS_PROMPTGUIDELINES = [
  "Information should be unique to the campaign",
  "Do not enter sensitive, confidential or proprietary information (e.g., patents, product recipes)",
  "Do not enter unethical or inaccurate information",
  "Always follow inclusive language guidelines",
];

export const BACKGROUND_REVIEW_ASSETS_CONSTANTS = {
  TITLE: GENERATED_ASSETS_CONSTANT.HEADING,
  HEADING_ID: "reviewGeneratedAssetsHeadingID",
  DESCRIPTION:
    'Your content is now available in the "Saved work" area. Please note: Assets are not ready to produce until they have completed proper legal review and approval.',
};

export const GENERATE_BACKGROUND_CONSTANTS: Record<number, object> = {
  1: BACKGROUND_EXPLORE_OPTIONS_CONSTANTS,
  2: BACKGROUND_INPUTS_CONSTANTS,
  3: BACKGROUND_REVIEW_ASSETS_CONSTANTS,
};

export const BACKGROUND_OPTIONS_DEFAULTS = {
  TITLE: "Background Generation",
  HEADING_ID: "backgroundHeadingID",
  ERROR_VARIANT: "error" as variantType,
  SUCCESS_VARIANT: "success" as variantType,
};

export const IS_AVAILABLE = "isAvailable";
